import { render } from "./ParkingDetails.vue?vue&type=template&id=52adde67&scoped=true"
import script from "./ParkingDetails.vue?vue&type=script&lang=js"
export * from "./ParkingDetails.vue?vue&type=script&lang=js"

import "./ParkingDetails.vue?vue&type=style&index=0&id=52adde67&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52adde67"]])

export default __exports__